import { defineComponent as _defineComponent } from 'vue';
import { ref, watch } from 'vue';
import { useActions, useState } from 'vuex-composition-helpers';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FeedBlogUrlEditDialog',
    props: {
        value: { type: Boolean },
        currentBlogUrl: null,
        feedId: null
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        const { patch: patchFeed } = useActions('feed', ['patch']);
        const { isPatchPending } = useState('feed', ['isPatchPending']);
        const blogUrl = ref('');
        watch(() => props.currentBlogUrl, (newBlogUrl) => blogUrl.value = newBlogUrl ?? '');
        async function saveRecord() {
            await patchFeed([props.feedId, { blogUrl: blogUrl.value }, {}]);
            emit('input', false);
        }
        return { __sfc: true, patchFeed, isPatchPending, emit, props, blogUrl, saveRecord };
    }
});
